import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { compose } from 'utils/react';
import { fromNamed, toNamed } from 'utils/colors';
import CurrentSiteContext from 'modules/react/contexts/CurrentSiteContext';
import Input from '../../../../../modules/react/components/stateful/Input';
import ColorPickerInput from '../../form/inputs/ColorPicker/ColorPicker';
import stylesGlobal from '../../../theme/facility-globals.scss';
import { section, editModal } from '../decorators';
import styles from './Banner.scss';
import FullWidth from './FullWidth';
import Ribbon from './Ribbon';
import BannerInput, { RIBBON } from './BannerInput';

class Banner extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    displayStyle: PropTypes.string,
    color: PropTypes.string,
  };

  renderStyle() {
    const { displayStyle, color } = this.props;

    if (displayStyle === RIBBON) {
      return (
        <CurrentSiteContext.Consumer>
          {({ theme }) => (
            <div className={`${styles.ribbon} ${styles.svg}`}>
              <Ribbon
                color={fromNamed(theme.colors, color)}
              />
            </div>
          )}
        </CurrentSiteContext.Consumer>
      );
    }
    return (
      <CurrentSiteContext.Consumer>
        {({ theme }) => (
          <div className={styles.svg}>
            <FullWidth
              color={fromNamed(theme.colors, color)}
            />
          </div>
        )}
      </CurrentSiteContext.Consumer>
    );
  }

  render() {
    const { children, displayStyle } = this.props;
    const [banner] = React.Children.toArray(children);

    return (
      <div className={`${stylesGlobal.sectionHeader} ${styles.bannerHeight}`}>
        {this.renderStyle()}
        <div
          className={`${displayStyle === RIBBON ? styles.ribbonText : styles.fullWidthText}
          ${styles.bannerText} ${styles.bannerFill}`}
        >
          {banner}
        </div>
      </div>
    );
  }
}

export default compose(
  editModal(
    { title: 'Banner Style' },
    () => (
      [{
        children: (
          <CurrentSiteContext.Consumer>
            {({ theme }) => (
              <div>
                <Field
                  component={BannerInput}
                  name="displayStyle"
                />
                <div className={`${styles.description} ${styles.bannerColor}`}>
                  Banner Color
                </div>
                <Field
                  component={Input}
                  name="color"
                  type="color"
                  className={styles.colorSelect}
                  format={value => fromNamed(theme.colors, value)}
                  normalize={value => toNamed(theme.colors, value)}
                />
                <Field
                  component={ColorPickerInput}
                  name="color"
                />
              </div>
            )}
          </CurrentSiteContext.Consumer>
        ),
      }]
    ),
  ),
  section(
    {
      name: 'Banner',
      category: 'Call to Action',
      defaultPayload: {
        displayStyle: 'FULLWIDTH',
        color: 'primary',
      },
    },
    {
      subsections: [
        { accepts: ['HeaderText'] },
      ],
      defaults: [
        ['HeaderText', {
          rawContentState: {
            blocks: [
              {
                key: 'db2mm',
                text: 'Customize your banner.',
                type: 'header-two',
                depth: 0,
                inlineStyleRanges: [],
                entityRanges: [],
              },
            ],
            entityMap: {},
          },
        }],
      ],
      menu: { items: ['edit', 'delete'] },
    },
  ),
)(Banner);
